const NotFoundEntityType = {
  COMMUNITYPOST: 'communityPost',
  DEFAULT: 'default',
};

export default NotFoundEntityType;
